module.exports = __webpack_public_path__ + "img/hr-red-pita-12.74de2333.png";